<template>
  <div class="Agenda subWrapper" ref="scrollBox" @scroll="handleScroll">
    <!-- logo + menu -->
    <LogoMenu :loadmounted="ismobile" :active-name="menuName" />
    <!-- mobile-大会日程 -->
    <div class="sub_contBox" ref="scrollBox_mob" v-if="!ismobile" @scroll="handleScroll">
      <div class="contbox_scroll">
        <div class="contbox_top">
          <!-- 大会日程 txt -->
          <div class="sub_title"><img src="../assets/image/right_arrow.png" /><span>{{ AgendaName }}</span><img src="../assets/image/left_arrow.png" /></div>
          <!-- 暂时 -->
          <!-- <div class="imgWrapper"><img src="../assets/image/Agenda.jpg" style="width: 100%;height: auto;" /></div> -->
          <!-- 时间 -->
          <ul class="timeBox" ref="boxFixed" :class="{'is_fixed' : isFixed}">
            <li v-for="(item,index) in activities" :key="index" :class="activeInd == index?'ActiveDate':''">
              <a href="javascript:void(0);" rel="external nofollow" @click="goAnchor(index)">
                <p class="month">{{ item.name }}</p>
                <p class="time">{{ item.name2 }}</p>
                <p class="line"></p>
              </a>
            </li>
          </ul>
          <!-- 内容 -->
          <div class="NewsCenter_cont sub_cont">
            <div v-for="(item,index) in activities" :key="index">
              <p class="cont_time" :id="'anchor-'+index">{{ item.name }}</p>
              <div class="specificInfo" v-for="(it,ind) in item.seminarNewsList" :key="ind" :id="indexToTitle == it.name ? 'indexTo' : ''">
                <a v-if="it.url" :href="it.url" target="_blank">{{ it.name }}</a>
                <a v-else href="javascript:;" style="cursor: default;">{{ it.name }}</a>
                <div class="timeline_wrap">
                  <el-timeline>
                    <el-timeline-item v-for="(act, i) in it.memo" :key="i" placement="top" color="#1058bb"
                      :hide-timestamp='true'>
                      <div class="item_info">
                        <p class="cont_timestamp">{{ act.date }}</p>
                        <a :href="act.url ? act.url : 'javascript:;'" class="cont_keyword">
                          <p v-for="(t, x) in act.themes" :key="x">{{ t }}</p>
                        </a>
                        <div class="cont_name">
                          <p v-for="(g, n) in act.guests" :key="n"><span class="name">{{ g.name }}</span> <span>{{ g.introduction }}</span></p>
                        </div>
                      </div>
                    </el-timeline-item>
                  </el-timeline>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 底部信息 -->
        <Foot />
      </div>
    </div>
    <!-- pc -->
    <div class="sub_contBox" ref="scrollBox" v-else>
      <!-- 面包屑 -->
      <div class="Breadcrumb_box">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>{{ AgendaName }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 主体 -->
      <div class="content_box agenda_contbox">
        <!-- 暂时 -->
        <!-- <div class="imgWrapper"><img src="../assets/image/Agenda.jpg" /></div> -->
        <!-- 时间 -->
        <ul class="timeBox" ref="boxFixed" :class="{'is_fixed' : isFixed}">
          <li v-for="(item,index) in activities" :key="index" :class="activeInd == index?'ActiveDate':''">
            <a href="javascript:void(0);" rel="external nofollow" @click="goAnchor(index)">
              <p class="month">{{ item.name }}</p>
              <p class="time">{{ item.name2 }}</p>
              <p class="line"></p>
            </a>
          </li>
        </ul>
        <!-- 内容 -->
        <div class="Agenda_cont sub_cont">
          <div v-for="(item,index) in activities" :key="index">
            <p class="cont_time" :id="'anchor-'+index">{{ item.name }}</p>
            <div class="specificInfo" v-for="(it,ind) in item.seminarNewsList" :key="ind" :id="indexToTitle == it.name ? 'indexTo' : ''">
              <a v-if="it.url" :href="it.url" target="_blank">{{ it.name }}</a>
              <a v-else href="javascript:;" style="cursor: default;">{{ it.name }}</a>
              <div class="timeline_wrap">
                <el-timeline>
                  <el-timeline-item v-for="(act, i) in it.memo" :key="i" placement="top" color="#1058bb"
                    :hide-timestamp='true'>
                    <a :href="act.url ? act.url: 'javascript:;'" class="item_info" :target="act.url ? '_blank' : '_self'" :style="act.url ? 'cursor: pointer;' : 'cursor: default;'">
                      <p class="cont_timestamp">{{ act.date }}</p>
                      <div class="cont_keyword">
                        <p v-for="(t, x) in act.themes" :key="x">{{ t }}</p>
                      </div>
                      <div class="cont_name">
                        <p v-for="(g, n) in act.guests" :key="n"><span class="name">{{ g.name }}</span> <span>{{ g.introduction }}</span></p>
                      </div>
                    </a>
                  </el-timeline-item>
                </el-timeline>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部信息 -->
    <Foot v-if="ismobile" />
  </div>
</template>

<script>
  import LogoMenu from '../components/LogoMenu.vue'
  import {
    DailyScheduleApi,AccessRecordsApi
  } from '../request/api.js'
  import Foot from '../components/Footer.vue'
  export default {
    name: "Agenda",
    data() {
      return {
        activities: [],
        Daily: [],
        activeInd: 0,
        AgendaName: '大会日程',
        ismobile: false,
        menuName: '',
        isFixed: false, // 吸顶
        offsetTop: 0, // 日程menu距离顶部的距离
        topicId: undefined,
        firstTo: true,
        indexToTitle: '',  // 首页分论坛title
      }
    },
    created() {
      let wid = window.innerWidth;
      if (wid >= 320 && wid <= 1024) {
        this.ismobile = false;
      } else {
        this.ismobile = true;
      }
      this.menuName = this.$route.query.name;
      this.topicId = this.$route.query.topicId;
      this.indexToTitle = this.$route.query.title;
    },
    mounted() {
      this.GetDailyFn();
      this.AccessRecordsFn();
      this.offsetTop = this.$refs.boxFixed.offsetTop;
    },
    methods: {
      // 访问记录
      AccessRecordsFn() {
        AccessRecordsApi({
          seminarTopicId: 7
        });
      },
      // 滚动 吸顶效果
      handleScroll(e) {
        let scrollTop = e.target.scrollTop + 60;
        this.isFixed = scrollTop > this.offsetTop ? true : false; // 如果滚动到顶部了，this.isFixed就为true
        this.firstTo = !this.isFixed;
      },
      // 日程安排
      GetDailyFn() {
        DailyScheduleApi(
          this.topicId
        ).then(res => {
          let arr = res.seminarSubTopics;
          this.Daily = res.seminarSubTopics[0].seminarNewsList;
          this.AgendaName = res.name;
          for(let i=0;i<arr.length;i++){
            for(let j=0;j<arr[i].seminarNewsList.length;j++){
              arr[i].seminarNewsList[j].memo = arr[i].seminarNewsList[j].memo ? JSON.parse(arr[i].seminarNewsList[j].memo) : [];
            }
          }
          this.activities = arr;

          // 跳到对应论坛
          if(!this.indexToTitle) return;
          setTimeout(()=>{
            this.IndexToTitleFn();
          },200);
        });
      },
      // 首页跳转到对应论坛
      IndexToTitleFn() {
          let f_top = document.getElementById('indexTo').offsetTop,
              dom = this.ismobile ? this.$refs.scrollBox : this.$refs.scrollBox_mob,
              num = 170;
          if (!this.firstTo) {
            num = this.isFixed ? 115 : 60
          }
          dom.scrollTop = f_top - num;
          let scrollTop = dom.scrollTop;
          this.isFixed = scrollTop > this.offsetTop ? true : false; // 如果滚动到顶部了，this.isFixed就为true
          this.firstTo = false;
      },
      // 锚点跳转
      goAnchor(i) {
        this.activeInd = i;
        let anchor = this.$el.querySelector('#anchor-' + i),
          dom = this.ismobile ? this.$refs.scrollBox : this.$refs.scrollBox_mob,
          num = 170;
        if (!this.firstTo) {
          num = this.isFixed ? 115 : 60
        }
        dom.scrollTop = anchor.offsetTop - num;
        let scrollTop = dom.scrollTop;
        this.isFixed = scrollTop > this.offsetTop ? true : false; // 如果滚动到顶部了，this.isFixed就为true
        this.firstTo = false;
      }
    },
    components: {
      LogoMenu,
      Foot
    }
  }
</script>

<style scoped>
  @media screen and (min-width: 1029px) {
    .Agenda {
      width: 100%;
      height: 100%;
      overflow: hidden;
      overflow-y: auto;
    }

    .agenda_contbox {
      display: flex;
      flex-direction: column;
    }

    /* 时间 */
    .timeBox {
      width: 100%;
      display: flex;
      flex-wrap: nowrap;
      overflow: hidden;
    }

    .timeBox li {
      width: 100%;
      margin-right: 1px;
      color: #d9d9d9;
      text-align: center;
      font-size: 16px;
      line-height: 24px;
    }

    .timeBox li .month {
      font-weight: bold;
    }

    .timeBox .ActiveDate p {
      color: #000000;
    }

    .timeBox .ActiveDate .line {
      opacity: 1;
    }

    .timeBox li .line {
      background-image: linear-gradient(#4332b5, #4332b5), linear-gradient(240deg, #cd4e90 0%, #f38f3f 100%);
      opacity: 0.4;
      height: 6px;
      background-blend-mode: normal, normal;
      margin-top: 1px;
    }

    /* 内容 */
    .cont_time {
      line-height: 40px;
      font-size: 16px;
      color: #333333;
      font-weight: bold;
      background-color: #f5f5f5;
      padding: 0 30px;
    }

    .cont_name .name{
      min-width: 50px;
      display: inline-block;
    }

    .specificInfo {
      padding: 0 30px;
      /* margin-bottom: 40px; */
    }

    .specificInfo>a {
      font-size: 18px;
      color: #1058bb;
      padding: 20px 0;
      display: inline-block;
      font-weight: bold;
    }

    .item_info {
      display: flex;
      padding: 0 0 20px;
      border-bottom: 1px solid #CCCCCC;
    }

    .item_info p {
      font-size: 16px;
      line-height: 24px;
      color: #333333;
    }

    .item_info .cont_timestamp {
      width: 95px;
    }

    .item_info .cont_keyword {
      width: 340px;
      margin: 0 50px 0 20px;
    }

    /* 吸顶 */
    .agenda_contbox .is_fixed {
      width: 1200px;
      position: fixed;
      top: 60px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 9;

      background-color: #FFFFFF;
    }
  }

  @media screen and (min-width: 320px) and (max-width: 1024px) {

    /* 时间 */
    .timeBox {
      width: 100%;
      display: flex;
      overflow: hidden;
      overflow-x: scroll;
    }

    .timeBox li {
      min-width: 2.3rem;
      margin-right: .1rem;
      font-size: .28rem;
      line-height: .4rem;
      color: #999999;
      text-align: center;
    }

    .timeBox .ActiveDate p {
      color: #000000;
    }

    .timeBox .ActiveDate .line {
      background-image: linear-gradient(#4332b5,
        #4332b5),
        linear-gradient(240deg,
        #cd4e90 0%,
        #f38f3f 100%);
    }

    .timeBox li .line {
      height: .12rem;
      background-image: linear-gradient(#0f86c4,
        #0f86c4),
        linear-gradient(240deg,
        #cd4e90 0%,
        #f38f3f 100%);
      background-blend-mode: normal,
        normal;
      margin-top: .1rem;
    }

    /* 内容 */
    .Agenda .sub_contBox .Agenda_cont {
      height: calc(100% - 2.3rem);
    }

    .cont_time {
      line-height: 40px;
      font-size: .28rem;
      color: #333333;
      font-weight: bold;
      background-color: #f5f5f5;
      padding: 0 15px;
    }

    .specificInfo {
      padding: 0 15px;
      /* margin-bottom: 40px; */
    }

    .specificInfo>a {
      font-size: .32rem;
      color: #000000;
      padding: 15px 0;
      display: inline-block;
      font-weight: bold;
    }

    .item_info p {
      font-size: 16px;
      line-height: 24px;
      color: #1058bb;
    }

    .item_info .cont_timestamp {
      color: #000000;
      font-size: .28rem;
    }

    .item_info .cont_keyword {
      color: #1058BB;
      font-size: .32rem;
      line-height: .6rem;
      display: block;
    }

    .item_info .cont_name span {
      display: block;
      font-size: .28rem;
      line-height: .4rem;
      color: #666666;
    }

    .item_info .cont_name .name {
      color: #000000;
    }

    /* 吸顶 */
    .is_fixed {
      width: calc(100% - 1.2rem);
      position: fixed;
      top: 1.2rem;
      left: 50%;
      transform: translateX(-50%);
      z-index: 11;

      background-color: #FFFFFF;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Agenda.vue